export default __webpack_public_path__ + "static/media/historybg.7303ab0c.svg";